const nebFoundationAddrs = [
  {
    address: "n1ZbXBzCqmSRsidsD27RL2qcJa4DdwghX5t",
    info: "Nas Reserved for the Nebulas Team",
    infoKey: "NasReservedForTeam",
    key: "team",
    status: "unreleased"
  },
  {
    address: "n1X3imkL6ZtHYJvHZdTuhBAGafYCj6cqnY6",
    info: "Nas Reserved for the Nebulas Team",
    infoKey: "NasReservedForTeam",
    key: "team",
    status: "unreleased"
  },
  {
    address: "n1VjCXwMdKisAzpCoGCPEWW23c8xoFcCaYE",
    info: "Nas Reserved for the Nebulas Team",
    infoKey: "NasReservedForTeam",
    key: "team",
    status: "unreleased"
  },
  {
    address: "n1cwsE8w4m6cRkr14R5c4hK3Lb9wPsUHhY9",
    info: "Go.Nebulas Fund",
    infoKey: "GoNebulasFund",
    key: "gn",
    status: "inCirculating"
  },
  {
    address: "n1TjEVnZ78QQTqCiZLtoqfvuZVJjTRcFHnh",
    info: "NAS Reserved for the ERC-20 token swap",
    infoKey: "NasReservedForSwap",
    key: "swap",
    status: "locked"
  },
  {
    address: "n1gczhpkT54RaT4PB55CNoYbqmEQcfo4hqq",
    info: "Burned Address",
    infoKey: "burnedAddress",
    key: "burned",
    status: "burned"
  }
];

export default nebFoundationAddrs;



// WEBPACK FOOTER //
// ./src/config/neb_foundation_addr.js